import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'types';
import { selectAlerts, selectOverdueAlerts } from '../../store/slice/selectors';
import { AlertBanner } from '../AlertBanner';
import { useSlideoutUrl } from 'app/hooks/useSlideoutUrl';
import { actions } from '../../store/slice';
import { AlertsAndNotification } from '../../store/types';
import styles from './AlertsContainer.module.scss';

export const AlertsContainer: React.FC = () => {
  const alerts = useSelector((state: RootState) => selectAlerts(state));
  const overdueAlerts = useSelector((state: RootState) =>
    selectOverdueAlerts(state)
  );
  const dispatch = useDispatch();
  const { openSlideout } = useSlideoutUrl();

  const handleAlertAction = (alert: AlertsAndNotification) => {
    if (alert.category !== 'ALERT' || !alert.issueId) return;

    // Issues may be absent on list payload; moment notifications load after open.
    openSlideout(alert.issueId);
  };

  const handleCloseAlert = (alertId: string) => {
    // Dispatch action to dismiss/remove the alert
    dispatch(actions.dismissAlert(alertId));
  };

  // Render server-loaded alerts and client-side overdue-feature alerts (CSME-112700) side by
  // side. Overdue-feature alerts are intentionally NOT aggregated — each overdue feature has its
  // own entry (own issueId) so every one is independently navigable.
  const activeAlerts = useMemo(() => {
    const serverAlerts = alerts.filter(alert => alert.category === 'ALERT');
    const overdue = overdueAlerts.filter(alert => alert.category === 'ALERT');
    return [...serverAlerts, ...overdue];
  }, [alerts, overdueAlerts]);

  if (activeAlerts.length === 0) {
    return null;
  }
  if (process.env.REACT_APP_DISPLAY_ALERTS === 'false') {
    return null;
  }
  return (
    <div className={styles.alertsContainer}>
      {activeAlerts.map(alert => (
        <AlertBanner
          key={alert.id}
          alert={alert}
          onAction={handleAlertAction}
          onClose={handleCloseAlert}
        />
      ))}
    </div>
  );
};
